import type { TFunction } from 'i18next';

import type { LockState } from '@/api/workflows';

/**
 * Compute the tooltip string for a card-action button on a workflow that may be
 * locked by another Originator. Used by Edit / Delete / Submit on the workflow
 * card so the three buttons stay in lockstep — when the workflow is held by a
 * colleague, every disabled button reads "Currently being edited by {name}"
 * instead of its normal positive copy.
 *
 * The colleague's display name comes from the lock payload (the holder snapshot
 * the BE persists at acquire time); when missing (legacy lock from before the
 * snapshot column shipped) we fall back to a generic "another user" string.
 */
export function lockedByOtherTooltip(lock: LockState | null | undefined, t: TFunction): string {
  return t('workflow.lock.bannerTitle', {
    name: lock?.holderName ?? t('workflow.lock.anotherUser'),
  });
}
